import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAIRankingCollectionService,
  getAIRankingNFTsService,
  getExploreCollectionRecordService,
  getTrendingCollectionService,
  searchFilterNFTsAndCollectionsService,
  searchNFTsAndCollectionsService,
} from "../../apiService/home";

interface TrendingCollectionPayload {
  page: number;
  limit: number;
  duration: string;
}

interface AIRankingNFTsPayload {
  limit?: number;
}

interface NFTsAndCollectionsPayload {
  keyword: string;
  limit: number;
}

interface FilterNFTsAndCollectionsPayload {
  keyword: string;
  limit: number;
  page: number;
  // name: string;
  blockchain_network: string;
  rank_by: string;
  category_id: string;
  eco_category_id: string;
}

export const getExploreCollectionRecord = createAsyncThunk(
  "vyga/getExploreCollectionRecord",
  async (_, { rejectWithValue }) => {
    try {
      const result = await getExploreCollectionRecordService();
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAIRankingNFTs = createAsyncThunk(
  "vyga/getAIRankingNFTs",
  async ({ limit }: AIRankingNFTsPayload, { rejectWithValue }) => {
    try {
      const result = await getAIRankingNFTsService(limit);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAIRankingCollection = createAsyncThunk(
  "vyga/getAIRankingCollection",
  async (_, { rejectWithValue }) => {
    try {
      const result = await getAIRankingCollectionService();
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const searchNFTsAndCollections = createAsyncThunk(
  "vyga/searchNFTsAndCollections",
  async (
    { keyword, limit }: NFTsAndCollectionsPayload,
    { rejectWithValue }
  ) => {
    try {
      const result = await searchNFTsAndCollectionsService(keyword, limit);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const filterSearchNFTsAndCollections = createAsyncThunk(
  "vyga/filterSearchNFTsAndCollections",
  async (
    {
      keyword,
      limit,
      page,

      blockchain_network,
      rank_by,
      eco_category_id,
      category_id,
    }: FilterNFTsAndCollectionsPayload,
    { rejectWithValue }
  ) => {
    try {
      const result = await searchFilterNFTsAndCollectionsService(
        keyword,
        limit,
        page,
        blockchain_network,
        rank_by,
        eco_category_id,
        category_id
      );
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getTrendingCollection = createAsyncThunk(
  "vyga/getTrendingCollection",
  async (
    { page, limit, duration }: TrendingCollectionPayload,
    { rejectWithValue }
  ) => {
    try {
      const result = await getTrendingCollectionService(page, limit, duration);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
